import {NuxtIcon} from "#components";
import {h} from "vue";
import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 96 96"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("path", { d: "M95.8 48.2C95.7 74.6 74.4 96 47.9 95.9 21.4 95.9.2 74.3.3 47.7.4 21.6 22 .2 48.1.3c26.3.1 47.8 21.6 47.7 47.9ZM48 90.4c23.3 0 42.2-18.9 42.2-42.3C90.2 25.4 72 5.9 48 5.8 24.3 5.8 5.7 25 5.7 48.1c.1 23.3 19 42.3 42.3 42.3Z" }, null, -1),
    _createElementVNode("path", { d: "M48 57.1c10.7.1 19.4 8.1 20.5 19 0 .5.1.9.1 1.4.1 1.6-.9 2.8-2.5 3-1.5.2-2.8-.8-3-2.4-.1-.9-.1-1.8-.3-2.6-1-5.9-4.4-10-10.1-11.9-5.6-1.9-10.7-.6-15.1 3.3-3.1 2.8-4.6 6.3-4.7 10.5-.1 2.2-1.4 3.4-3.3 3.1-1.3-.2-2.2-1.2-2.3-2.6-.1-3.6.8-6.9 2.5-10 3.5-6.1 8.7-9.6 15.7-10.5.9-.2 1.7-.3 2.5-.3ZM32.3 48.5a7.2 7.2 0 1 0 0-14.4 7.2 7.2 0 0 0 0 14.4ZM64.5 48.5a7.2 7.2 0 1 0 0-14.4 7.2 7.2 0 0 0 0 14.4Z" }, null, -1)
  ]))]))
}
export default { render() { return h(NuxtIcon, {icon: {render}, name: "SmileyRate2"}) } }